"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tsParticles = exports.pJSDom = exports.particlesJS = exports.Utils = exports.Constants = exports.ColorUtils = exports.CanvasUtils = void 0;
const tslib_1 = require("tslib");
const pjs_1 = require("./pjs");
const main_1 = require("./main");
const Utils_1 = require("./Utils");
Object.defineProperty(exports, "CanvasUtils", { enumerable: true, get: function () { return Utils_1.CanvasUtils; } });
Object.defineProperty(exports, "ColorUtils", { enumerable: true, get: function () { return Utils_1.ColorUtils; } });
Object.defineProperty(exports, "Constants", { enumerable: true, get: function () { return Utils_1.Constants; } });
Object.defineProperty(exports, "Utils", { enumerable: true, get: function () { return Utils_1.Utils; } });
const tsParticles = new main_1.Main();
exports.tsParticles = tsParticles;
tsParticles.init();
const { particlesJS, pJSDom } = pjs_1.initPjs(tsParticles);
exports.particlesJS = particlesJS;
exports.pJSDom = pJSDom;
tslib_1.__exportStar(require("./Core/Container"), exports);
tslib_1.__exportStar(require("./Enums"), exports);
tslib_1.__exportStar(require("./Plugins/Absorbers/Enums"), exports);
tslib_1.__exportStar(require("./Plugins/Emitters/Enums"), exports);
tslib_1.__exportStar(require("./Plugins/PolygonMask/Enums"), exports);
tslib_1.__exportStar(require("./Types"), exports);
